import { render, staticRenderFns } from "./DialogTextDetail.vue?vue&type=template&id=4a4c2f8e&scoped=true&"
import script from "./DialogTextDetail.vue?vue&type=script&lang=js&"
export * from "./DialogTextDetail.vue?vue&type=script&lang=js&"
import style0 from "./DialogTextDetail.vue?vue&type=style&index=0&id=4a4c2f8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4c2f8e",
  null
  
)

export default component.exports